<template>
  <a :href="href" v-bind="$attrs"><slot></slot></a>
</template>

<script>
export default {
  name: 'FancyButton',
  props: {
    href: {
      type: String,
      required: false
    }
  },
  methods: {
    handleClick (e) {
      if (this.$attrs.href) {
        window.location.href = this.$attrs.href
        this.$emit('click', e)
      }
    }
  }
}
</script>

<style scoped>
button, a {
  background-color: transparent;
  border-image-source: url('@/assets/img/rect111.png');
  border-image-slice: 2 12.5 12.5 2;
  display: inline-block;
  box-sizing: content-box;
  padding: 10px 0px 0 10px;
  border-width: 2px 12.5px 12.5px 2px;
  border-color: gold;
  border-style: solid;
  /* transition-property: border-image-source, background-slice, color;
  transition-duration: 0.5s; */
  color: white;
  text-decoration: none;
  cursor: pointer;
}

button:hover, a:hover {
  border-image-source: url('@/assets/img/rect112.png');
  border-image-slice: 2 12.5 12.5 2 fill;
  color: black;
}
</style>
